// tslint:disable
import { callStatic, QuestionsListResponse } from 'services/api-service'

/**
 * List of questions
 *
 * @method
 * @name ApiService#questionsList
 * @param {string} sku - 
 * @param {integer} offset - 
 * @param {integer} limit - 
 * @param {string} sort - Default value depends on site settings:
 * RECENT
 * OLDEST
 * BEST
 * MOST_ANSWERS
 * LEAST_ANSWERS
 * MOST_RECENT_ANSWER
 * OLDEST_ANSWER

 * @param {boolean} includeRelated - 
 */
function questionsList(parameters: {
  sku: string
  offset: number
  limit: number
  sort:
    | 'RECENT'
    | 'OLDEST'
    | 'BEST'
    | 'MOST_ANSWERS'
    | 'LEAST_ANSWERS'
    | 'MOST_RECENT_ANSWER'
    | 'OLDEST_ANSWER'
  includeRelated?: boolean
}): Promise<QuestionsListResponse> {
  return callStatic<QuestionsListResponse>(
    '/sitedata/{siteKey}/{sku}/d/question/{locale}/{offset}/{limit}/{sort}/{includeRelated}',
    parameters,
    ['sku', 'offset', 'limit', 'sort']
  )
}

export default { questionsList }
